export default {
  SET_REMITTANCE_LIST: (state, list) => {
    state.list = list;
  },
  SET_TOTAL_REMITTANCE_LIST: (state, { total, totalSum }) => {
    state.total = total;
    state.totalSum = totalSum;
  },
  SET_SELECTED: (state, payload) => {
    state.selected = payload;
  },
  SET_TABLE_OPTIONS: (state, payload) => {
    state.tableOptions = payload;
  },
  RESET_TABLE_OPTIONS: (state) => {
    state.tableOptions.page = 1;
  },
  SET_REMITTANCE_CUSTOMERS: (state, customers) => {
    state.customers = customers;
  },
};
